import { render } from "./RelationAdd.vue?vue&type=template&id=26925b3d"
import script from "./RelationAdd.vue?vue&type=script&lang=js"
export * from "./RelationAdd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__